export const BRAZIL_REGULATIONS_POPUP_OPEN_EVENT = 'brazil-regulations-popup:open'
export const BRAZIL_REGULATIONS_POPUP_ACCEPT_EVENT = 'brazil-regulations-popup:accept'

export const openBrazilRegulationsPopup = () => {
  if (typeof window === 'undefined') {
    return
  }

  window.dispatchEvent(new Event(BRAZIL_REGULATIONS_POPUP_OPEN_EVENT))
}

export const notifyBrazilRegulationsPopupAccepted = () => {
  if (typeof window === 'undefined') {
    return
  }

  window.dispatchEvent(new Event(BRAZIL_REGULATIONS_POPUP_ACCEPT_EVENT))
}
